import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import Loader from "react-loader-spinner";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import deliveryService from "../services/delivery-service";
import moment from "moment";

const tablePropsInit = {
  columns: [
    { key: "patient_name", title: "Patient" },
    { key: "drg_name", title: "Drug" },
    { key: "rxf_num", title: "Rx #" },
    { key: "label_count", title: "Labels" },
    { key: "fil_qty", title: "Fill Qty", style: { textAlign: "left" } },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "del_id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 50,
    position: PagingPosition.Bottom,
  },
};
const tableNotScannedPropsInit = {
  columns: [
    { key: "patient_name", title: "Patient" },
    { key: "drg_name", title: "Drug", style: { textAlign: "left" } },
    { key: "rxf_num", title: "Rx #" },
    { key: "scan_count", title: "Scan Count" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "del_id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 50,
    position: PagingPosition.Bottom,
  },
};
const CustomCellDate = ({ rowData }) => {
  return (
    <div>
      <span className="inline-block mr-3">
        {moment.utc(rowData?.scan_date).format("MM-DD-YYYY") || ""}
      </span>
    </div>
  );
};
const CustomCellScanCount = ({ rowData }) => {
  return (
    <div>
      <span className="inline-block mr-3">
        {rowData?.scan_number + " of " + rowData?.label_count}
      </span>
    </div>
  );
};

const CustomCell = ({ rowData }) => {
  return (
    <div className="text-sm">
      {rowData?.pat_lname + ", " + rowData?.pat_fname}
    </div>
  );
};

const Delivery = () => {
  const [loading, setLoading] = useState(false);
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const [allRecords, setAllRecords] = useState([]);
  const [tableNotScannedProps, changeTableNotScannedProps] = useState(
    tableNotScannedPropsInit
  );
  const [rxcode, setRxcode] = useState("");
  const [scannedCount, setScannedCount] = useState(0);
  const [unscannedCount, setUnscannedCount] = useState(0);
  const dispatch1 = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData && rxcode !== "") {
      try {
        dispatch1(updateData([]));
        setScannedCount(0);
      } catch (e) {
        setLoading(false);
        const { hide } = cogoToast.error(
          "Error retrieving delivery information. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    }
  };
  const dispatchNotScanned = async (action) => {
    try {
      changeTableNotScannedProps((prevState) => kaReducer(prevState, action));
      if (action.type === ActionType.LoadData) {
        dispatchNotScanned(updateData([]));
        setUnscannedCount(0);
      }
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error retrieving delivery information. Please contact administrator.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const getRecords = async (e) => {
    try {
      var code = e.target.value;
      if (e.key === "Enter" && rxcode !== "") {
        setLoading(true);
        setRxcode('');
        let rxfNum = code.length >= 11 ? code.substring(0, 8) : code;
        rxfNum = rxfNum.charAt(0) == '0' ? rxfNum.substring(1, rxfNum.length) : rxfNum;

        var scannedItem = allRecords.findIndex(
          (item) => item.rxf_num.toString() === rxfNum
        );
        let resp = allRecords;
        if (scannedItem === -1) {
          resp = await deliveryService.getRecords(code);
          scannedItem = resp?.findIndex(
            (item) => item.rxf_num.toString() === rxfNum
          );
        }
        if (resp[scannedItem]?.scan_number < resp[scannedItem]?.label_count || resp[scannedItem].scan_flag === 'F') {
          var scanResp =  await deliveryService.scanRecord({
            del_id: resp[scannedItem].del_id,
            scan_flag: "T",
          });
          if (scanResp?.refresh === 'T')  {
            resp = await deliveryService.getRecords(code);
          } else {
            resp[scannedItem].scan_number = resp[scannedItem].scan_number + 1;
            if (
              resp[scannedItem]?.scan_number === resp[scannedItem]?.label_count
            ) {
              resp[scannedItem].scan_flag = "T";
            }
          }
        }else {
          const { hide } = cogoToast.success("This RX number is already scanned", {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          });
        }
        var sItems = resp.filter((item) => item.scan_flag === "T");
        dispatch1(updateData(sItems));
        setScannedCount(sItems?.length);
        var fItems = resp.filter((item) => item.scan_flag !== "T");
        var fItem = fItems?.find((item) => item.rxf_num.toString() === rxfNum);
        if (fItem) {
          fItems = fItems?.filter((item) => item.rxf_num.toString() !== rxfNum);
          fItems.unshift(fItem);
        }

        dispatchNotScanned(updateData(fItems));
        setUnscannedCount(fItems?.length);
        setAllRecords(resp);
        setLoading(false);
      }
    } catch (ex) {
      setLoading(false);
      setRxcode("");
      const { hide } = cogoToast.error(ex.message, {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    }
  };

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="bg-white w-11/12 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 h-24">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">Delivery Reconciliation</span>
          </div>
        </div>
        <div className="w-full pt-4 pl-2 justify-center">
          <ul>
            <li className="inline-block text-xs pr-3 leading-6 text-menu_txt w-full mb-3">
              <div className="flex w-full">
                <label className="text-labelclr mt-1 mr-3 ml-2 font-semibold text-xl tracking-wider">
                  Scan Rx Number
                </label>
                <div className="w-1/3">
                  <input
                    type="text"
                    name="rxCode"
                    id="rxCode"
                    value={rxcode}
                    autoFocus={true}
                    placeholder="Scan RX Number"
                    onChange={(e) => setRxcode(e.target.value)}
                    onKeyDown={(e) => getRecords(e)}
                    className="border focus:outline-none  w-full focus:none h-10 rounded-md pl-3 text-sm font-normal w-full"
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="w-full flex px-3 py-3">
          <div className="w-1/3 border px-3 py-3 mr-1">
            <div className="tableHeader flex clearboth ">
              <div className="w-1/2 text-darkclr font-semibold leading-10 truncate">
                <label className="text-labelclr font-semibold text-md tracking-wider">
                  NOT SCANNED {unscannedCount ?  " (" +unscannedCount + ")" : ""}
                </label>
              </div>
              <div className="w-full sm:w-1/2 text-right">
                <span className="relative">
                  <input
                    type="search"
                    defaultValue={tableNotScannedProps.searchText}
                    onChange={(event) => {
                      dispatchNotScanned(search(event.currentTarget.value));
                    }}
                    placeholder=" Search"
                    className="border rounded w-full mb-2 h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
                  />
                  <img
                    src="/img/search-2.svg"
                    alt=""
                    className="absolute w-4 h-4 right-5 -top-3"
                  ></img>
                </span>
              </div>
            </div>
            <div className=" text-xs usersList gridList overflow-x-auto">
              <Table
                {...tableNotScannedProps}
                childComponents={{
                  cellText: {
                    content: (props) => {
                      // eslint-disable-next-line default-case
                      switch (props.column.key) {
                        case "scan_count":
                          return <CustomCellScanCount {...props} />;
                        case "patient_name":
                          return <CustomCell {...props} />;
                      }
                    },
                  },
                }}
                dispatch={dispatchNotScanned}
              />
            </div>
          </div>
          <div className="w-2/3 border px-3 py-3 justify-end">
            <div className="tableHeader flex clearboth pl-3">
              <div className="w-1/2 text-darkclr font-semibold leading-10 ">
                <label className="text-labelclr font-semibold text-md tracking-wider">
                  SCANNED  {scannedCount ?  " (" +scannedCount + ")" : ""}
                </label>
              </div>
              <div className="w-full sm:w-1/2 text-right">
                <span className="relative">
                  <input
                    type="search"
                    defaultValue={tableProps.searchText}
                    onChange={(event) => {
                      dispatch1(search(event.currentTarget.value));
                    }}
                    placeholder=" Search"
                    className="border rounded  mb-2 h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
                  />
                  <img
                    src="/img/search-2.svg"
                    alt=""
                    className="absolute w-4 h-4 right-5 -top-3"
                  ></img>
                </span>
              </div>
            </div>

            <div className=" text-xs usersList gridList overflow-x-auto">
              <Table
                {...tableProps}
                childComponents={{
                  cellText: {
                    content: (props) => {
                      // eslint-disable-next-line default-case
                      switch (props.column.key) {
                        case "patient_name":
                          return <CustomCell {...props} />;
                        case "scan_date":
                          return <CustomCellDate {...props} />;
                      }
                    },
                  },
                }}
                dispatch={dispatch1}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(Delivery)
);
